import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { Period } from '@/lib/timePeriod';
import type { AlertTrendResponse } from '@/types/fraudHub';

/**
 * Fetches the chart-ready stacked-by-severity fraud-alert time series from the
 * NEW `/fraud-hub/alert-trend` endpoint (backed by the
 * `analytics.fraud_alert_daily_by_dim` MV). Period-aware: the backend buckets
 * day/week/month from the resolved period and returns `bucket_size` so the SPA
 * can pick the X-axis tick formatter.
 */
export function useFraudHubAlertTrend(
  period: Period,
  groupBy: 'severity' = 'severity',
): UseQueryResult<AlertTrendResponse, Error> {
  return useQuery<AlertTrendResponse, Error>({
    queryKey: ['fraud-hub', 'alert-trend', period, groupBy],
    queryFn: async () => {
      const { data } = await api.get<AlertTrendResponse>(
        '/fraud-hub/alert-trend',
        { params: { period, group_by: groupBy } },
      );
      return data;
    },
    staleTime: 30_000,
  });
}
